import Logo from '../logos/theda';

export default Logo;
